const angular = require('angular');

const { FulfilmentTimeslotService } = require('./fulfilment-timeslot.service');
const { fulfilmentTimetableComponentDefinition } = require('./fulfilment-timetable.component');
const { timeslotAlertComponentDefinition } = require('./timeslot-alert.component');

angular.module('wowApp.fulfilment')
    .service('FulfilmentTimeslotService', FulfilmentTimeslotService)
    .component('wowFulfilmentTimetable', fulfilmentTimetableComponentDefinition)
    .component('wowTimeslotAlert', timeslotAlertComponentDefinition);



// WEBPACK FOOTER //
// ./src/fulfilment/timeslots/index.js